import { Container } from "@mui/material";
import { DataStoreBreadcrumbs } from "~/components/DataStoreBreadcrumbs";
import { Page } from "~/components/Page";
import { DigestionTopicCreateForm } from "./components/DigestionTopicCreateForm";

export function NewDigestionTopicPage() {
  return (
    <Page title="New Digestion Topic">
      <Container fixed>
        <DataStoreBreadcrumbs />
        <DigestionTopicCreateForm />
      </Container>
    </Page>
  );
}
